import * as Yup from 'yup';
import _countBy from 'lodash/countBy';
import { EMAIL_PATTERN } from '../constants/patterns';
import _find from 'lodash/find';
import _isUndefined from 'lodash/isUndefined';
import { CHECK_DIGIT_TYPE_NONE } from '../constants/constants';

Yup.addMethod(Yup.string, 'phone', function(message) {
  return this.test('phone-validation', message, function(value) {
    const { path, createError } = this;

    if (!value) {
      return true;
    }

    const validPatterns = ['^\\d\\s?\\(\\d{3}\\)\\s\\d{3}-\\d{4}', '^\\d{12}'];
    const isValid = validPatterns.some(pattern => {
      const regex = new RegExp(pattern);
      return regex.test(value);
    });

    if (!isValid) {
      return createError({ path, message });
    }
    return true;
  });
});

Yup.addMethod(Yup.string, 'integer', function(message) {
  return this.test('integer-validation', message, function(value) {
    const { path, createError } = this;

    const isValid = Number.isInteger(Number(value));

    if (!isValid) {
      return createError({ path, message });
    }
    return true;
  });
});

Yup.addMethod(Yup.string, 'positive', function(message) {
  return this.test('positive-validation', message, function(value) {
    const { path, createError } = this;

    const isValid = Math.sign(value) > 0;

    if (!isValid) {
      return createError({ path, message });
    }
    return true;
  });
});

Yup.addMethod(Yup.string, 'eProFormat', function(message, checkDigitType) {
  return this.test('e-pro-forma-validation', message, function(value) {
    const { path, createError } = this;
    if (!value) {
      return true;
    }

    const validPatterns =
      checkDigitType === CHECK_DIGIT_TYPE_NONE
        ? [
            '^(\\w+-?)?((#+)-?)$',
            '^((#+)-?)+(\\w+-?)$',
            '^((#+)-?)+(\\w+-?)?((#+)-?)$'
          ]
        : [
            '^(\\w+-?)?((#+)-?)+@$',
            '^((#+)-?)+(\\w+-?)?@$',
            '^((#+)-?)+(\\w+-?)?((#+)-?)+@$'
          ];

    const isValid = validPatterns.some(pattern => {
      const regex = new RegExp(pattern);
      return regex.test(value);
    });

    if (!isValid) {
      return createError({ path, message });
    }

    return true;
  });
});

Yup.addMethod(Yup.string, 'eProFormatLength', function(length, message) {
  return this.test('e-pro-forma-validation', message, function(value) {
    const { path, createError } = this;
    if (!value) {
      return true;
    }

    if (length && _countBy(value)['#'] !== length) {
      return createError({ path, message });
    }

    return true;
  });
});

Yup.addMethod(Yup.string, 'greaterThan', function(ref, msg) {
  return this.test({
    name: 'greaterThan',
    exclusive: false,
    // eslint-disable-next-line
    message: msg || '${path} must be greater than ${reference}',
    params: {
      reference: ref.path
    },
    test: function(value) {
      return value >= this.resolve(ref);
    }
  });
});

Yup.addMethod(Yup.number, 'decimals', function(decimals, msg) {
  return this.test('decimal-validation', msg, function(value) {
    const { path, createError } = this;

    // Determine if the value is populated
    if (isNaN(value) || value === null) {
      return true;
    }

    // Check for appropriate decimal places
    const regex = new RegExp(`^\\d+(?:\\.\\d{1,${decimals}})?$`);
    const isValid = regex.test(value);

    if (!isValid) {
      return createError({ path, msg });
    }
    return true;
  });
});

Yup.addMethod(Yup.string, 'zip', function(message) {
  return this.test('zipcode-validation', message, function(value) {
    // If this is a null zip return true and let a .required validate that it should be entered
    if (!value) {
      return true;
    }

    const { path, createError } = this;
    const validPatterns = [
      '^\\d{5}([-]?\\d{4})?$',
      '^[ABCEGHJ-NPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ -]?\\d[ABCEGHJ-NPRSTV-Z]\\d$'
    ];
    const isValid = validPatterns.some(pattern => {
      const regex = new RegExp(pattern, 'i');
      return regex.test(value);
    });
    if (!isValid) {
      return createError({ path, message });
    }
    return true;
  });
});

Yup.addMethod(Yup.string, 'email', function(message) {
  return this.test('email-validation', message, function(value) {
    // If this is a null email address return true and let a .required validate that it should be entered
    if (!value) {
      return true;
    }

    const { path, createError } = this;
    const regex = new RegExp(EMAIL_PATTERN);
    const isValid = regex.test(value);

    if (!isValid) {
      return createError({ path, message });
    }

    return true;
  });
});

Yup.addMethod(Yup.string, 'userEmailUnique', function(message, users) {
  return this.test('user-email-validation', message, function(value) {
    const { path, createError } = this;
    const isValid = _isUndefined(_find(users, { email: value }));

    if (!isValid) {
      return createError({ path, message });
    }
    return true;
  });
});

Yup.addMethod(Yup.string, 'glCodeUnique', function(glCodes, message) {
  return this.test('glCode-validation', message, function(value) {
    const { path, createError } = this;
    const isValid = _isUndefined(_find(glCodes, { externalId: value }));

    if (!isValid) {
      return createError({ path, message });
    }
    return true;
  });
});

Yup.addMethod(Yup.string, 'glCodeNameUnique', function(glCodes, message) {
  return this.test('glCode-validation', message, function(value) {
    const { path, createError } = this;
    const isValid = _isUndefined(_find(glCodes, { name: value }));

    if (!isValid) {
      return createError({ path, message });
    }
    return true;
  });
});
